export default class AuthInfo {
  constructor(props) {
    this.AccessKeyId = props.AccessKeyId
    this.SecretAccessKey = props.SecretAccessKey
    this.SessionToken = props.SessionToken
  }
}
